<template>
  <div class="container-fluid py-2">
    <div class="row">
      <div class="col-12 col-md-10 col-lg-6 mx-auto">
        <div class="lpg-form px-3">
          <form>
            <h2 class="my-5 lpg-form-title">Ingresar a perfil</h2>
            <div v-if="errors.credentials" class="alert alert-danger" role="alert">
              Correo / Contraseña incorrectos
            </div>
            <text-input
              id="email"
              v-model="login_data.email"
              type="email"
              placeholder="Correo electrónico"
              :required="true"
              icon="bi bi-envelope"
              icon_color="#8e8e8e"
            ></text-input>
            <text-input
              id="password"
              v-model="login_data.password"
              type="password"
              placeholder="Contraseña"
              :required="true"
              icon="bi bi-lock"
              icon_color="#8e8e8e"
            ></text-input>

            <div class="mb-1 text-end">
              <Link :href="$route('password.request')" class="btn btn-link mt-1"
                >He olvidado mi contraseña</Link
              >
            </div>

            <div class="mb-4 text-end">
              <button type="submit" @click.prevent="login" class="btn btn-secondary mt-1">
                Ingresa
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import TextInput from '@/Components/Form/TextInput'

export default {
  name: 'Ingreso',
  layout: Layout,
  props: {
    errors: Object,
  },
  components: {
    Link,
    TextInput,
  },
  data() {
    return {
      login_data: {
        email: '',
        password: '',
      },
    }
  },
  methods: {
    login() {
      this.$inertia.post('/ingreso', this.login_data)
    },
  },
}
</script>
